import _typeof from "/builds/karvy/dit-react/packages/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/typeof";

/*!
 * isobject <https://github.com/jonschlinkert/isobject>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */
export default function isObject(val) {
  return val != null && _typeof(val) === 'object' && Array.isArray(val) === false;
}
;